import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';


const useStyles_Affiliate = makeStyles({
    icon: {
        width: 24,
        marginRight: 5,
        marginTop: 8,
        color:'#ffbf09'
    }
});

export function AffiliateIcon() {
    const classes = useStyles_Affiliate();
    
    return <img src="/assets/images/new_icons/affiliate.png" className={classes.games} alt="Affiliate" />
}


const useStyles_Bonus = makeStyles({
    icon: {
        width: 36,
        marginRight: 5,
        marginTop: 5,
        marginLeft:5,
         color:'#ffbf09'
    }
});

export function BonusIcon() {
    const classes = useStyles_Bonus();
    return <img src="/assets/images/new_icons/rakeback.png" className={classes.icon} alt="Bonus" />
}


const useStyles_Desposit = makeStyles({
    icon: {
        width: 36,
        marginRight: 5,
        marginTop: 5
    }
});

export function DespositIcon() {
    const classes = useStyles_Desposit();
    return <img src="/assets/images/new_icons/deposit.png" className={classes.icon} alt="Deposit" />
}



const useStyles_Games = makeStyles({
    games: {
        width: 38,
        marginRight: 5,
        marginTop: 6,
        color:'#ffbf09'
    }
});

export function GamesIcon() {
    const classes = useStyles_Games();
    return <img src="/assets/images/new_icons/originalgames.png" className={classes.games} alt="Games" />
}


const useStyles_Home = makeStyles({
    games: {
        width: 38,
        marginRight: 5,
        marginTop: 3,
        color:'#ffbf09'
    }
});

export function HomeIcon() {
    const classes = useStyles_Home();
    return <img src="/assets/images/new_icons/home.png" className={classes.games} alt="Home" />
}


const useStyles_LiveSupport = makeStyles({
    slot: {
        width: 35,
        verticalAlign: '-13px'
    }
});

export function LiveSupportIcon(){
    const classes = useStyles_LiveSupport();
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 48C141.124 48 48 141.125 48 256s93.124 208 208 208c114.875 0 208-93.125 208-208S370.875 48 256 48zm-21.549 384.999c-39.464-4.726-75.978-22.392-104.519-50.932C96.258 348.393 77.714 303.622 77.714 256c0-42.87 15.036-83.424 42.601-115.659.71 8.517 2.463 17.648 2.014 24.175-1.64 23.795-3.988 38.687 9.94 58.762 5.426 7.819 6.759 19.028 9.4 28.078 2.583 8.854 12.902 13.498 20.019 18.953 14.359 11.009 28.096 23.805 43.322 33.494 10.049 6.395 16.326 9.576 13.383 21.839-2.367 9.862-3.028 15.937-8.13 24.723-1.557 2.681 5.877 19.918 8.351 22.392 7.498 7.497 14.938 14.375 23.111 21.125 12.671 10.469-1.231 24.072-7.274 39.117zm147.616-50.932c-25.633 25.633-57.699 42.486-92.556 49.081 4.94-12.216 13.736-23.07 21.895-29.362 7.097-5.476 15.986-16.009 19.693-24.352 3.704-8.332 8.611-15.555 13.577-23.217 7.065-10.899-17.419-27.336-25.353-30.781-17.854-7.751-31.294-18.21-47.161-29.375-11.305-7.954-34.257 4.154-47.02-1.417-17.481-7.633-31.883-20.896-47.078-32.339-15.68-11.809-14.922-25.576-14.922-42.997 12.282.453 29.754-3.399 37.908 6.478 2.573 3.117 11.42 17.042 17.342 12.094 4.838-4.043-3.585-20.249-5.212-24.059-5.005-11.715 11.404-16.284 19.803-24.228 10.96-10.364 34.47-26.618 32.612-34.047s-23.524-28.477-36.249-25.193c-1.907.492-18.697 18.097-21.941 20.859.086-5.746.172-11.491.26-17.237.055-3.628-6.768-7.352-6.451-9.692.8-5.914 17.262-16.647 21.357-21.357-2.869-1.793-12.659-10.202-15.622-8.968-7.174 2.99-15.276 5.05-22.45 8.039 0-2.488-.302-4.825-.662-7.133a176.585 176.585 0 0 1 45.31-13.152l14.084 5.66 9.944 11.801 9.924 10.233 8.675 2.795 13.779-12.995L282 87.929V79.59c27.25 3.958 52.984 14.124 75.522 29.8-4.032.361-8.463.954-13.462 1.59-2.065-1.22-4.714-1.774-6.965-2.623 6.531 14.042 13.343 27.89 20.264 41.746 7.393 14.801 23.793 30.677 26.673 46.301 3.394 18.416 1.039 35.144 2.896 56.811 1.788 20.865 23.524 44.572 23.524 44.572s10.037 3.419 18.384 2.228c-7.781 30.783-23.733 59.014-46.769 82.052z"></path></svg>
}


const useStyles_Setting = makeStyles({
    icon: {
        width: 36,
        marginRight: 5,
        marginTop: 5
    }
});

export function SettingIcon() {
    const classes = useStyles_Setting();
    return <img src="/assets/images/new_icons/setting.png" className={classes.icon} alt="Setting" />
}


const useStyles_Slots = makeStyles({
    icon: {
        width: 34,
        marginRight: 5
    }
});

export function SlotsIcon() {
    const classes = useStyles_Slots();
    return <img src="/assets/images/new_icons/slots.svg" className={classes.icon} alt="Slots" />
}


const useStyles_VerifyResult = makeStyles({
    slot: {
        width: 30,
        marginRight: 5
    }
});

export function VerifyResultIcon(){
    const classes = useStyles_VerifyResult();
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M202.7 341.3V170.7c0-23.5 19-42.7 42.7-42.7h197v-21.3c0-23.5-18.9-42.7-42.3-42.7H92c-23.7 0-44 18.5-44 42v300c0 23.5 20.3 42 44 42h308c23.5 0 42.3-19.2 42.3-42.7V384h-197c-23.6 0-42.6-19.2-42.6-42.7z"></path><path d="M245 186v140c0 8.8 7.2 16 16 16h187c8.8 0 16-7.2 16-16V186c0-8.8-7.2-16-16-16H261c-8.8 0-16 7.2-16 16zm77.1 101.9c-19.3 1.2-35.2-14.7-34-34 1-15.9 13.9-28.8 29.9-29.9 19.3-1.2 35.2 14.7 34 34-1.1 16-14 28.9-29.9 29.9z"></path></svg>
}


const useStyles_Vip = makeStyles({
    icon: {
        width: 42,
        marginRight: 5,
        marginTop: 1,
        color:'#ffbf09'
    }
});

export function VipIcon() {
    const classes = useStyles_Vip();
    return <svg fill="#ffbf09" className={classes.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M424 134.5h-45.8c2.3-6.6 3.8-13.9 3.8-21.3 0-35.4-28.1-63.2-63-63.2-22.1 0-41.2 10.7-52.5 28L256 92.3l-10.5-14.5C234.2 60.7 215.1 48 193 48c-34.9 0-63 29.8-63 65.2 0 7.5 1.5 14.7 3.8 21.3H88c-23.3 0-41.8 19-41.8 42.7L46 421.8c0 23.7 17.4 42.2 40.7 42.2h336.7c23.3 0 42.7-18.5 42.7-42.2V177.2c-.1-23.7-18.8-42.7-42.1-42.7zM320 91c11.6 0 21 9.5 21 21 0 11.6-9.4 21-21 21s-21-9.5-21-21 9.4-21 21-21zm-128 0c11.6 0 21 9.5 21 21 0 11.6-9.4 21-21 21s-21-9.5-21-21 9.4-21 21-21zM88 177.2h106.7L151 237.5l34 25 50-69.1.2-.2-.2 228.6H88V177.2zm336 244.6H277V193.4l50 69.1 34-25-43.7-60.4H424v244.7z"></path>
    </svg>
}
